import { useNavigate } from "react-router-dom";
import "../../featured-products/components/modalproductdetail.css";
import Logo from "@/assets/imgs/logo.png";
import { truncateText } from "../../../lib";

export const ModalProductoBuscado = ({ show, setShow, items }) => {
  const navigate = useNavigate();
  const isCompanyFlow = location.pathname.startsWith("/company");
  const handleClose = () => {
    setShow(false);
  };


  const machineClick = (machine) => {
    setShow(false);
    navigate(isCompanyFlow ? `/company/store/${machine}` : `/store/${machine}`, { replace: true });
  };
 
  if (show)
    return (
      <div className="modal-overlay">
        <div className="modal-container">
          <button className="close-button" onClick={handleClose}>
            &times;
          </button>

          <h2 className="modal-title">
            Tiendas donde puedes encontrar este producto
          </h2>

          <div className="product-summary">
            {items.length > 0 ? 
            <>
             <img
              src={items[0].producto_foto || Logo}
              alt={items[0].producto_nombre}
              className="summary-image-buscado"
            />
            <div className="summary-info">
              <a href="#" className="product-name-link">
                {items[0].producto_nombre}
              </a>
              <p>
                {truncateText(items[0].producto_descripcion)}
              </p>
              </div>
            </>
            :
            <>
             <p>No hay tiendas disponibles para este producto</p>
            </>
            
            }
           
            
          </div>
          <div className="store-info">
            {/* <div className="store-header">
              <img
                src={store.current.logo_empresa}
                alt="brand"
                className="brand-logo"
              />
              <h2>{store.current.empresa_nombre}</h2>
            </div> */}

            {items.map((machine, index) => (
              <div className="store-card" key={index} onClick={()=>machineClick(machine.maquina_id)}>
                <div className="store-main">
                  <div className="store-main-div">
                    <div className="store-main-name">
                      <h4>{machine.maquina_nombre}</h4>

                      {/* <span className="fav-heart"></span> */}
                    </div>
                    <div className="location-product">
                      <i className="icon-location"></i>
                      <span className="text-location">
                        {machine.maquina_direccion +", "+machine.region_nombre}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="">
                  <i className="icon-store-arrow"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
};
